export default __webpack_public_path__ + "static/media/08302021.3297343a.png";